// src/varconfig.ts
import { envRequired, envString, envBool } from "./env";

export const VARCONFIG = {
  WS_URL: envString("VITE_PGBROADCAST_WS_URL"),
  API_URL: envRequired("VITE_API_BASE"),
  KC_URL: envRequired("VITE_KC_URL"),
  KC_REALM: envRequired("VITE_KC_REALM"),
  KC_CLIENT_ID: envRequired("VITE_KC_CLIENT_ID"),
  VERIFY_SSL: envBool("VITE_VERIFY_SSL", true),
  LOG_LEVEL: envString("VITE_LOG_LEVEL", "info"),
};
